import React, { useState, useEffect } from 'react';
import './CountdownTimer.css';

const CountdownTimer = ({
  endDate = null,
  initialHours = 0,
  initialMinutes = 10,
  initialSeconds = 0,
  labelText = 'Offer ends in:',
  valueProposition = '',
  showValueProposition = true,
  resetWhenExpired = true,
  onExpire = null,
  className = ''
}) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: initialHours,
    minutes: initialMinutes,
    seconds: initialSeconds
  });

  useEffect(() => {
    // Removed console.log for cleaner logs
    
    const timer = setInterval(() => {
      if (endDate) {
        const target = new Date(endDate);
        const now = new Date();
        const diff = target - now;
        
        // Removed console.log for cleaner logs

        if (diff <= 0) {
          // Removed console.log for cleaner logs
          if (onExpire) onExpire();
          clearInterval(timer);
          setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
          return; // stop early
        }

        const secondsTotal = Math.floor(diff / 1000);
        const days = Math.floor(secondsTotal / (3600 * 24));
        const hours = Math.floor((secondsTotal % (3600 * 24)) / 3600);
        const minutes = Math.floor((secondsTotal % 3600) / 60);
        const seconds = secondsTotal % 60;

        // Removed console.log for cleaner logs
        setTimeLeft({ days, hours, minutes, seconds });
      } else {
        // Removed console.log for cleaner logs
        // legacy behaviour
        setTimeLeft(prev => {
          if (prev.seconds > 0) {
            return { ...prev, seconds: prev.seconds - 1 };
          } else if (prev.minutes > 0) {
            return { ...prev, minutes: prev.minutes - 1, seconds: 59 };
          } else if (prev.hours > 0) {
            return { ...prev, hours: prev.hours - 1, minutes: 59, seconds: 59 };
          } else {
            if (onExpire) onExpire();
            if (resetWhenExpired) {
              return { days: 0, hours: initialHours, minutes: initialMinutes, seconds: initialSeconds };
            }
            return prev;
          }
        });
      }
    }, 1000);
    
    return () => clearInterval(timer);
  }, [endDate, initialHours, initialMinutes, initialSeconds, resetWhenExpired, onExpire]);
  
  return (
    <div className={`countdown-container ${className}`}>
      {showValueProposition && (
        <div className="countdown-value-proposition">{valueProposition}</div>
      )}
      <div className="countdown-timer">
        <span className="countdown-label">{labelText}</span>
        <span aria-live="polite" className="countdown-timer-values">
          {endDate && (
            <>
              <span className="timer-value">{timeLeft.days.toString().padStart(2, '0')}</span>d :
            </>
          )}
          <span className="timer-value">{timeLeft.hours.toString().padStart(2, '0')}</span>:
          <span className="timer-value">{timeLeft.minutes.toString().padStart(2, '0')}</span>:
          <span className="timer-value">{timeLeft.seconds.toString().padStart(2, '0')}</span>
        </span>
      </div>
    </div>
  );
};

export default CountdownTimer;
